import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  mode: 0,
  selectedRangeDate: [dayjs().add(-7, "d"), dayjs()],
  multiDate: [dayjs().format("YYYY-MM-DD")],
  selectedTimeRange: [
    dayjs("00:00:00", "HH:mm:ss"),
    dayjs("23:59:59", "HH:mm:ss"),
  ],
  tabList: [],
  selectedTab: [],
  selectedTabAll:"video",
  creditScore:{}
};

const filterSlice = createSlice({
  name: "filterReducer",
  initialState,
  reducers: {
    setMode: (state, action) => {
      const mode = action.payload;
      state.mode = mode;
    },
    setSelectedRangeDate: (state, action) => {
      const date = action.payload;
      state.selectedRangeDate = date;
    },
    setSelectedTimeRange: (state, action) => {
      const date = action.payload;
      state.selectedTimeRange = date;
    },
    setMultiDate: (state, action) => {
      const date = action.payload;
      state.multiDate = date;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload?.tab;
    },
    setSelectedTabAll: (state, action) => {
      state.selectedTabAll = action.payload;
    },
    setCreditScore: (state, action) => {
      state.creditScore = action.payload;
    },
    
  },
});

export const {
  setMode,
  setMultiDate,
  setSelectedRangeDate,
  setSelectedTab,
  setSelectedTimeRange,
  setSelectedTabAll,setCreditScore
} = filterSlice.actions;
export default filterSlice.reducer;
